export const influences = [
      {
            title: 'Social Media',
            id: 'Social Media'
      },
      {
            title: 'Friend',
            id: 'Friend'
      },
      {
            title: 'Family',
            id: 'Family'
      },
      {
            title: 'Others',
            id: 'Others'
      }
];

export const feedbacks = [
      {
            title: 'Poor',
            id: 'Poor'
      },
      {
            title: 'Fair',
            id: 'Fair'
      },
      {
            title: 'Good',
            id: 'Good'
      },
      {
            title: 'V. Good',
            id: 'V. Good'
      },
      {
            title: 'Excellent',
            id: 'Excellent'
      }
];

export const projectTypes = [
      {
            title: 'Residence',
            id: 'Residence'
      },
      {
            title: 'Commercial',
            id: 'Commercial'
      },
      {
            title: 'Hotel',
            id: 'Hotel'
      },
      {
            title: 'Institutional',
            id: 'Institutional'
      },
      {
            title: 'Hospital',
            id: 'Hospital'
      }
];
